
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.77 6.485c0 2.068-1.73 3.725-3.89 3.725S3.99 8.553 3.99 6.486 5.72 2.76 7.88 2.76s3.89 1.657 3.89 3.725zM2 14.429c0-1.915 2.708-2.394 5.88-2.394 3.188 0 5.879.496 5.879 2.412 0 1.914-2.709 2.393-5.88 2.393C4.691 16.84 2 16.344 2 14.429zM13.339 6.553c0 1.053-.33 2.035-.91 2.852-.06.084-.007.197.098.215.146.023.295.037.448.04 1.518.038 2.881-.898 3.258-2.308.558-2.092-1.08-3.97-3.166-3.97a3.4 3.4 0 00-.654.064c-.03.006-.06.02-.076.043-.02.031-.006.07.015.097.627.842.987 1.866.987 2.967zM15.854 11.132c1.02.19 1.691.58 1.97 1.147a1.615 1.615 0 010 1.47c-.426.878-1.797 1.16-2.33 1.233a.164.164 0 01-.187-.181c.272-2.435-1.894-3.59-2.454-3.855-.024-.012-.03-.03-.027-.042.002-.008.012-.02.03-.022 1.212-.023 2.516.137 2.998.25z","fill":"#94A3B8"}})])
          )
        }
      }
    